module.exports = __webpack_public_path__ + "static/img/公司团队.3141152.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/公司团队.jpg
// module id = Pvlb
// module chunks = 1